import React from 'react';




function compute_polarity(matches_str, polarity, correction) {

    if (correction) {
        return 'message-domain corrected ' + polarity
    }

  // temporary, need to change the match structure
  return 'message-domain ' + polarity

  if (matches_str === undefined || matches_str.length === 0)
    return ''
  var matches = []
  // console.log(Object.prototype.toString.call(matches_str))
  // console.log(typeof matches_str)
  try { // new matching format
    matches_str.map((m) => {
      const sim = JSON.parse(m)
      matches.push(sim)
    })
  } catch { // old matching format
    matches = JSON.parse(matches_str)
  }
  var polarity = 'positive'
  var max = 0.15
  for (var k in matches) {
    let val = matches[k]
    if (val.concept === undefined && val.similarity === undefined) {  // compat ascendante, temporaire
      for (var v in val) {
        if (val[v][0] >= max) {
          max = val[v][0]
        }
      }
    } else {
      if (val.concept !== undefined) {
        continue
      }
      const pondered_similarity = val.pondered_similarity
      if (pondered_similarity >= max) {
        if (val.nickName === 'S') {
          polarity = 'negative'
        }
        max = pondered_similarity
    }
  }

  }
  return 'message-domain ' + polarity
}



function formatMatchedDomains(matches_str, correction) {
  if (matches_str === undefined || matches_str.length === 0)
    return ''
  if (correction !== '') {
    return correction
  }
  var matches = []
  // console.log(Object.prototype.toString.call(matches_str))
  // console.log(typeof matches_str)
  try { // new matching format
    matches_str.map((m) => {
      const sim = JSON.parse(m)
      matches.push(sim)
      return true
    })
  } catch { // old matching format
    matches = JSON.parse(matches_str)
  }
  var matches_res = ''
  var max = 0.3
  for (var k in matches) {
    let val = matches[k]
    if (val.concept === undefined && val.similarity === undefined) {  // compat ascendante, temporaire
      for (var v in val) {
        if (val[v][0] >= max) {
          matches_res = val[v][1]
          max = val[v][0]
        }
      }
    } else {
      if (val.concept !== undefined) {
        continue
      }
      const pondered_similarity = val.pondered_similarity
      if (pondered_similarity >= max) {
        matches_res = val.nickName
        max = pondered_similarity
    }
  }

  }
  return matches_res
}


const ChatMessage = ({content, isSelf, isCurrentTarget, origin, stamp, formatTimestamp, scrollMessages, 
        domain_correction,  domain_polarity, domain_matches='', speaker='', overThresholdMessages=[], colorScale=null}) => {


  const pointMessage = () => {
      scrollMessages(stamp)
  };
  const i = overThresholdMessages.indexOf(stamp)
  const color = i >= 0 && colorScale != null ? colorScale(i) : 'wheat'
  return (
    <div key={stamp} className={`message ${isSelf ? 'self' : ''}`}>
      <div id={`message_${stamp}`} onMouseDown={pointMessage} className='message-content'>
      <span className="message-user">{isSelf ? '' : origin}</span>
        <span onClick={pointMessage} className={isCurrentTarget ? 'message-date current_target' : 'message-date'}>{formatTimestamp(stamp)}</span>
        <span className='message-line'>{content}</span>
        {i >= 0 && <span style={{ border: `3px solid ${color}` }} className={compute_polarity(domain_matches, domain_polarity, domain_correction)}>{formatMatchedDomains(domain_matches, domain_correction)}</span>}
        <span className="message-speaker">{speaker}</span>
      </div>
    </div>
  );
};

export default ChatMessage;